import React from "react";

import PublicLayout from "../../components/universal/public-layout";
import PublicNavigation from "../../components/universal/public-navigation";
import PublicFrontpageContent from "../../components/public/frontpage";
import PublicFooter from "../../components/universal/public-footer";
import { Helmet } from "react-helmet-async";

const Frontpage = () => {
  return (
    <>
      <Helmet>
        <title>Leadfind - Salgsverktøy og CRM</title>
        <meta name="thumbnail" content="https://leadfind.no/showcase.jpg" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Leadfind er et enkelt men svært effektivt og brukervennlig CRM og salgsverktøy som gir gode resultater for virksomheter som jobber både B2B og B2C."
        />
        <meta name="author" content="Leadfind" />
        <meta
          name="keywords"
          content="prospecting, salgsverktøy, salg, nye kunder, crm"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content="https://leadfind.no/" />
        <meta name="twitter:title" content="Leadfind - Salgsverktøy og CRM" />
        <meta
          name="twitter:description"
          content="Leadfind er et enkelt men svært effektivt og brukervennlig CRM og salgsverktøy som gir gode resultater for virksomheter som jobber både B2B og B2C."
        />
        <meta name="twitter:image" content="https://leadfind.no/showcase.jpg" />

        <meta property="og:url" content="https://leadfind.no/" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Leadfind - Salgsverktøy og CRM" />
        <meta
          property="og:description"
          content="Leadfind er et enkelt men svært effektivt og brukervennlig CRM og salgsverktøy som gir gode resultater for virksomheter som jobber både B2B og B2C."
        />
        <meta property="og:image" content="https://leadfind.no/showcase.jpg" />
        <link rel="canonical" href="https://leadfind.no/" />
      </Helmet>
      <PublicLayout
        Navigation={() => <PublicNavigation />}
        Content={() => <PublicFrontpageContent />}
        Footer={() => <PublicFooter />}
      />
    </>
  );
};

export default Frontpage;
